<div class="text-center">
    <p *ngIf="componentState === 'loading'">Detecting the connection attempt...</p>
    <p *ngIf="componentState === 'authenticating'">Authenticating. Please wait...</p>
    <p *ngIf="componentState === 'authenticated'">Redirecting...</p>
    <p *ngIf="componentState === 'nocode'">It seems you skipped some steps trying to connect to Xero. You can try to reconnect if you want.</p>
    <p *ngIf="componentState === 'error'">We couldn't connect you to Xero for some reason. This happens from time to time. You can try to reconnect if you want.</p>

    <div *ngIf="(integrationInfo$ | async) as integration">
        <app-oauth2-button *ngIf="['nocode', 'error'].includes(componentState)" [integration]="integration"></app-oauth2-button>
    </div>
    
    <div class="position-relative mt-5 text-center">
        <ngx-loading [show]="['loading', 'authenticating', 'authenticated'].includes(componentState)"></ngx-loading>
    </div>
</div>